import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Variables = {
  emailId: string;
  matchedSubTopicId: string | null;
};

async function updateEmailMatchedTopic(variables: Variables) {
  const { data, error } = await apiClient
    .from('inbox_emails')
    .update({
      matched_sub_topic_id: variables.matchedSubTopicId,
      updated_at: new Date().toISOString(),
    })
    .eq('id', variables.emailId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export function useUpdateEmailMatchedTopic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEmailMatchedTopic,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.inbox });
      enqueueSnackbar('Sujet associé à l’email mis à jour.', 'success');
    },
    onError: (err: Error) => {
      enqueueSnackbar(err.message || 'Impossible de mettre à jour le sujet.', 'error');
    },
  });
}
